import React, { useEffect, useState } from 'react';
import './TreatHistory.css';

const API_BASE = process.env.REACT_APP_API_URL || 'https://api.petlings.gg/api/v1';

function formatDate(iso) {
  try {
    return new Date(iso).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
  } catch {
    return iso;
  }
}

export default function TreatHistory({ limit = 10 }) {
  const [state, setState] = useState({ status: 'loading', grants: [] });

  useEffect(() => {
    let cancelled = false;
    fetch(`${API_BASE}/shop/grants/history?limit=${limit}`, { credentials: 'include' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('bad status'))))
      .then((data) => {
        if (cancelled) return;
        setState({ status: 'ready', grants: data.grants || [] });
      })
      .catch(() => {
        if (cancelled) return;
        setState({ status: 'unavailable', grants: [] });
      });
    return () => { cancelled = true; };
  }, [limit]);

  return (
    <div className="treat-history card">
      <h3 className="treat-history-title">Treat history</h3>

      {state.status === 'loading' && (
        <p className="treat-history-empty">Loading…</p>
      )}

      {state.status === 'unavailable' && (
        <div className="treat-history-empty-state">
          <img src="/branding/petlings-pet-128.png" alt="" width={72} height={72} className="treat-history-empty-art" />
          <p className="treat-history-empty">
            Treat history is coming soon. For now, claim grants right from the
            banner when one is available.
          </p>
        </div>
      )}

      {state.status === 'ready' && state.grants.length === 0 && (
        <div className="treat-history-empty-state">
          <img src="/branding/petlings-pet-128.png" alt="" width={72} height={72} className="treat-history-empty-art" />
          <p className="treat-history-empty">
            No grants yet - log in daily and watch for event drops.
          </p>
        </div>
      )}

      {state.status === 'ready' && state.grants.length > 0 && (
        <ul className="treat-history-list">
          {state.grants.map((g) => (
            <li key={g.id} className="treat-history-row">
              <div>
                <span className="treat-history-source">{g.source}</span>
                <span className="treat-history-date">{formatDate(g.granted_at)}</span>
              </div>
              <span className="treat-history-amount">+{g.amount} 🦴</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
